import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";
import { comparisons } from "@/data/comparisons";
import { PageEssentials, PageOutro } from "@/components/site/PageEssentials";
import heroCompare from "@/assets/hero/hero-compare.jpg.asset.json";

const HERO = {
  src: heroCompare.url,
  alt: "Two loan comparison sheets side by side on a desk with a calculator and house keys — comparing DSCR and investor loan programs",
};

export const Route = createFileRoute("/compare/")({
  head: () =>
    buildHead({
      title: "Loan Program Comparisons — Simply Approved Mortgages",
      description:
        "Head-to-head comparisons of DSCR, conventional, foreign national, ITIN, bridge, and hard money loan programs.",
      url: "/compare",
      keywords:
        "DSCR vs conventional loan, DSCR vs ITIN loan, foreign national vs DSCR loan, bridge loan vs hard money, loan program comparison, investor loan comparison, compare mortgage programs, DSCR vs bank statement loan, business purpose loan comparison, compare rental property loans",
      image: HERO.src,
      imageAlt: HERO.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "Compare", url: "/compare" },
      ],
      service: { name: "Loan Program Comparison Hub" },
    }),
  component: CompareIndex,
});

function CompareIndex() {
  return (
    <SiteShell>
      <PageHero eyebrow="Compare" title="Loan program comparisons" subtitle="Side-by-side breakdowns to help investors pick the right financing path." image={HERO} />
      <PageEssentials />
      <Section>
        <div className="grid gap-6 md:grid-cols-2">
          {comparisons.map((c) => (
            <Link key={c.slug} to="/compare/$slug" params={{ slug: c.slug }} className="rounded-xl border border-border bg-card p-6 transition-colors hover:border-brand-gold">
              <h2 className="font-display text-xl font-bold text-brand-dark">{c.title}</h2>
              <p className="mt-2 text-sm text-muted-foreground">{c.intro.slice(0, 180)}…</p>
              <div className="mt-4 text-sm font-semibold text-brand">Read comparison →</div>
            </Link>
          ))}
        </div>
      </Section>
    <PageOutro />
      </SiteShell>
  );
}
